import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function MessageAlert({ children }) {
  return (
    <>
      <FontAwesomeIcon icon={['fas', 'exclamation-circle']} style={{ color: `var(--primary-color)` }} /> &nbsp;{children}
    </>
  );
}
